import { useMutation } from 'react-query';
import type { PaymentMethodViewDto } from '@subscriptions/application/dtos';
import { getPaymentMethodUseCases } from '@subscriptions/composition';
import type { PaymentMethodTypeType } from '@subscriptions/domain/types';

/**
 * Hook for imperatively fetching the organization's saved payment methods of a
 * given type (`GET /v1/payment-methods?type=…`) — CARD in the saved-cards flow.
 *
 * Modeled as a mutation (same idiom as `useGenerateBlockReference`) because the
 * listing runs on demand from the fiscal-data step's Continuar, not as a cached
 * query: the wizard needs the fresh list exactly once to decide between the
 * saved-cards step and the Stripe checkout. The use case already filters out
 * non-ACTIVE methods.
 *
 * @returns React Query mutation result resolving with the saved methods
 */
export const useListSavedCards = () => {
  const { listPaymentMethods } = getPaymentMethodUseCases();

  return useMutation<PaymentMethodViewDto[], Error, PaymentMethodTypeType>((type) => listPaymentMethods.execute(type));
};
